import { Routes, Route, Navigate } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm, ForgotPasswordForm, ResetPasswordForm } from './components';

export default function UnauthenticatedContent() {
  return (
    <Routes>
      <Route
        path='/login'
        element={
          <SingleCard title="Logg inn" >
            <LoginForm />
          </SingleCard>
        }
      />
      <Route
        path='/forgot-password'
        element={
          <SingleCard title="Glemt passord">
            <ForgotPasswordForm />
          </SingleCard>
        }
      />
      <Route
        path='/reset-password/:clientName/:employeeNo/:token'
        element={
          <SingleCard title="Nytt passord">
            <ResetPasswordForm />
          </SingleCard>
        }
      />
      <Route path='*' element={<Navigate to={'/login'} />}></Route>
    </Routes>
  );
}
